import { render } from "./AboutBio.vue?vue&type=template&id=1b29ed15&scoped=true"
const script = {}

import "./AboutBio.vue?vue&type=style&index=0&id=1b29ed15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b29ed15"]])

export default __exports__